import {Map, List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import AccountItem from 'web-app/react/entities/account-items/model';
import BillPayer from 'web-app/react/entities/bill-payers/model';
import Children from 'web-app/react/entities/children/model';
import Warning from 'web-app/react/entities/warnings/model';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import {type DateTimePeriod} from './types';

export const fetchInvoicingBillPayers = (institutionId: string, from: string, to: string) =>
    RESTClient.getAuthenticatedObservable(`v2/invoicing/${institutionId}/invoices/billPayers`, {
        from,
        to,
        includeInvoices: true,
    }).map(data => ({
        behaviors: new BehaviorsCollection(data.behaviors),
        billPayers: List(data.billPayers).map(BillPayer.fromAPI),
        children: List(data.children).map(Children.fromAPI),
        warnings: List(data.warnings).map(Warning.fromAPI),
        invoices: Map(data.invoices),
    }));

export const batchInvoice = (
    institutionId: string,
    billPayerIds: List<string>,
    invoiceData: DateTimePeriod & {preview: boolean},
) => {
    return RESTClient.postAuthenticatedObservable(`v2/invoicing/${institutionId}/invoices`, {
        billPayerIds,
        ...invoiceData,
    });
};

export const previewBatchInvoice = (institutionId: string, billPayerIds: List<string>, invoiceData: DateTimePeriod) => {
    return batchInvoice(institutionId, billPayerIds, {
        ...invoiceData,
        preview: true,
    }).map(data =>
        Map(data.invoices).map((invoiceData: any) => {
            if (invoiceData.error) {
                return {
                    ...invoiceData,
                    invoices: List(),
                };
            }
            return {
                invoices: List(invoiceData).map(AccountItem.fromAPI),
            };
        }),
    );
};
